import { render, staticRenderFns } from "./NewCognitiveLevelDimensionsST.vue?vue&type=template&id=f69059ba&scoped=true"
import script from "./NewCognitiveLevelDimensionsST.vue?vue&type=script&lang=js"
export * from "./NewCognitiveLevelDimensionsST.vue?vue&type=script&lang=js"
import style0 from "./NewCognitiveLevelDimensionsST.vue?vue&type=style&index=0&id=f69059ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f69059ba",
  null
  
)

export default component.exports